export default __webpack_public_path__ + "static/media/trr-event-bodypainting.01b9a227.png";